import {Component, OnInit, ViewChild} from '@angular/core';
import {MatSort} from '@angular/material/sort';
import {UtilisateurService} from '../../../service/utilisateur.service';
import {AppelService} from '../../../service/appel.service';
import {ConfigService} from '../../../service/config.service';
import {MatTableDataSource} from '@angular/material/table';
import {Appel} from '../../../modele/appel';
import {MatPaginator} from '@angular/material/paginator';

@Component({
  selector: 'app-bilandiscussion',
  templateUrl: './bilandiscussion.component.html',
  styleUrls: ['./bilandiscussion.component.css']
})
export class BilandiscussionComponent implements OnInit {
  listeUtilisateur;
  listappels;
  datedeb;
  datefin;
  utili;
  niveauInteret;
  canal;
  total;

  displayedColumns: string[] = ['Date', 'NomPrenoms', 'Telephone1', 'Par', 'Discussion', 'Interet', 'Relancer'];
  dataSource = new MatTableDataSource<any>(this.listappels);

  constructor(private utilisateurService: UtilisateurService,
              private appelService: AppelService,
              private configService: ConfigService) { }

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  ngOnInit() {
    this.chargeUtilisateur();
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.dataSource.filterPredicate = function(data, filter: string): boolean {
      return  data.Conver_Interresse.toString() === filter || data.Conver_Type.toString() === filter;
    };
    this.total = this.dataSource.data.length;
  }

  chargeUtilisateur() {
    this.utilisateurService.readUtilisateur().subscribe(user => {
      this.listeUtilisateur = user;
    });
  }

  submit(form) {
    this.configService.recherche = 1;
    this.appelService.readdiscussionConversation(JSON.stringify(form.value)).subscribe(list => {
     console.log(list);
       if (list == null) {
        this.total = this.dataSource.data.length;
        this.configService.recherche = 0;
        return;
      } else {
        this.listappels = list;
        this.dataSource.data = list;
        this.configService.recherche = 0;
        this.total = this.dataSource.data.length;
      }

    }, () => {
      this.total = this.dataSource.data.length;
      this.configService.recherche = 0;
      return;

    });

  }

  applyFilter() {
    //  alert(this.niveauInteret);
    this.canal = '';
    this.dataSource.filter = this.niveauInteret;
    this.total = this.dataSource.filteredData.length;
    // this.getTotalCost();
  }

  applyFilter2() {
    // alert(this.canal);
    this.niveauInteret = '';
    this.dataSource.filter = this.canal;
    this.total = this.dataSource.filteredData.length;

  }

  /** Gets the total cost of all transactions.
   getTotalCost() {
    return this.listappels.map(t => t.ART_PRIX).reduce((acc, value) => acc + value, 0);
  }*/


}
